import confirmAuth from "./confirmAuth"

export default  confirmAuth;
